import { HttpErrorResponse, HttpEventType, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, tap, throwError } from 'rxjs';
import { ConnectivityService } from '../services/connectivity.service';
import { SKIP_OFFLINE_REPORT } from './http-context.tokens';

export const offlineInterceptor: HttpInterceptorFn = (req, next) => {
  const connectivity = inject(ConnectivityService);

  if (req.context.get(SKIP_OFFLINE_REPORT)) {
    return next(req);
  }

  return next(req).pipe(
    tap((event) => {
      if (event.type === HttpEventType.Response) {
        connectivity.reportReachable();
      }
    }),
    catchError((error: unknown) => {
      // Only status 0 means no HTTP response came back at all. A 4xx/5xx
      // proves the round trip worked, so treating those as offline would
      // turn every permission denial into a "connection lost" banner.
      if (error instanceof HttpErrorResponse && error.status === 0) {
        connectivity.reportSuspectedOutage();
      }
      return throwError(() => error);
    })
  );
};
